import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AccountRoleRegisterComponent } from './account-role-register/containers/account-role-register.component';
import { AccountRoleRegisterViewComponent } from './account-role-register/views/account-role-register-view.component';
import { RoleRegisterEffects } from './state/role-register.effects';
import { roleRegisterFeatureKey, roleRegisterReducer } from './state/role-register.reducer';
import { SystemRoleRegisterComponent } from './system-role-register/containers/system-role-register.component';
import { SystemRoleRegisterViewComponent } from './system-role-register/views/system-role-register-view.component';

@NgModule({
   declarations: [
      SystemRoleRegisterViewComponent,
      SystemRoleRegisterComponent,
      AccountRoleRegisterComponent,
      AccountRoleRegisterViewComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      MatMenuModule,
      EffectsModule.forFeature([RoleRegisterEffects]),
      StoreModule.forFeature(roleRegisterFeatureKey, roleRegisterReducer),
   ],
})
export class RoleRegisterModule {}
